import {IResultAndError, getObjectWithApiError} from '../../lib/ChoiceApi';

export enum LockboxErrorMessage {
    Insurance = "Unable to return Insurance ePayments.",
    Patient = "Unable to return Patient ePayments."
};
export enum LockboxReportType {
    Patient = 1,
    Insurance = 2
};
export enum LockboxDateType {
    Deposit = 1,
    Lockbox = 2
};
export enum LockboxStatusType {
    All = 1,
    Error = 2,
    Success = 3,
    Unprocessed = 4
};
export interface ILockboxInputs 
{ 
    ReportType: LockboxReportType, 
    DateType: LockboxDateType,
    StatusType: LockboxStatusType,
    StartDate?: string,
    EndDate?: string
};
export interface IInsuranceLockboxReport 
{ 
    id: number,
    vendorName: string, 
    fileName: string,
    lockBoxDateTimeEDT: string,
    fileStatusID?: number,
    fileStatus?: string
};
export interface IPatientLockboxReport 
{ 
    id: number,
    vendorName: string, 
    fileName: string,
    lockBoxDateTimeEDT: string,
    chart?: number,
    patientName?: string,
    statementID1?: string,
    statementID2: string,
    depositDate?: string,
    depositCheck?: string,
    depositAmount?: number,
    paymentType?: number,
    paymentTypeDescription?: string,
    paymentMethod?: number,
    paymentMethodDescription?: string,
    fileStatusID?: number,
    fileStatus?: string
}; 
export async function GetInsuranceReport(lockBoxData: ILockboxInputs): Promise<IResultAndError<IInsuranceLockboxReport[]>>{  
    const url = `api/Deposits/LockboxReport/Insurance?dateType=${lockBoxData.DateType}&statusType=${lockBoxData.StatusType}&startDate=${lockBoxData.StartDate}&endDate=${lockBoxData.EndDate}`;
    return await getObjectWithApiError(url);
}
export async function GetPatientReport(lockBoxData: ILockboxInputs): Promise<IResultAndError<IPatientLockboxReport[]>>{  
    const url = `api/Deposits/LockboxReport/Patient?dateType=${lockBoxData.DateType}&statusType=${lockBoxData.StatusType}&startDate=${lockBoxData.StartDate}&endDate=${lockBoxData.EndDate}`
    return await getObjectWithApiError(url);          
}